import React, { useState } from 'react';

export default function AITutor({ courseTitle }) {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);

  const sendMessage = async () => {
    if (!input.trim()) return;

    const newMessages = [...messages, { role: 'user', content: input }];
    setMessages(newMessages);
    setInput('');
    setLoading(true);

    try {
      console.log("Sending to OpenAI:", JSON.stringify({
        model: "gpt-4",
        messages: [
          {
            role: "system",
            content: `You are an AI tutor for the course titled "${courseTitle}". Only answer questions related to that course.`,
          },
          ...messages,
          { role: "user", content: input }
        ]
      }));

      const response = await fetch('/api/ask', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          question: input,
          courseTitle,
          messages: newMessages,
        }),
      });

      console.log("Raw response:", response);

      const data = await response.json();
      console.log("Parsed data:", data);

      const botReply = data.reply || "Sorry, something went wrong.";
      setMessages([...newMessages, { role: 'assistant', content: botReply }]);
    } catch (err) {
      console.error("Fetch error:", err);
      setMessages([...newMessages, {
        role: 'assistant',
        content: `Error: ${err.message || "Could not reach AI tutor."}`
      }]);
    }

    setLoading(false);
  };

  return (
    <div className="bg-white border p-4 rounded shadow">
      <div className="mb-4 h-64 overflow-y-auto space-y-2">
        {messages.map((msg, i) => (
          <div
            key={i}
            className={`p-2 rounded ${msg.role === 'user' ? 'bg-indigo-100 text-right' : 'bg-gray-100 text-left'}`}
          >
            {msg.content}
          </div>
        ))}
        {loading && <p className="text-sm italic text-gray-500">Thinking...</p>}
      </div>
      <div className="flex gap-2">
        <input
          className="flex-1 border rounded p-2"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Ask a question about this course..."
        />
        <button
          onClick={sendMessage}
          className="bg-indigo-600 text-white px-4 py-2 rounded hover:bg-indigo-700"
        >
          Send
        </button>
      </div>
    </div>
  );
}
